var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import classNames from "classnames";
const Note = (_a) => {
    var { className, icon, note, owner, infoRight, highlight } = _a, props = __rest(_a, ["className", "icon", "note", "owner", "infoRight", "highlight"]);
    const { fullName, title, extra } = owner;
    return (React.createElement("div", Object.assign({}, props, { className: classNames("gerudo-note", className, {
            "gerudo-note-highlight": highlight,
        }) }),
        React.createElement("header", null,
            React.createElement("div", { className: "gerudo-note-owner-info" },
                icon && React.createElement("div", { className: "gerudo-icon-container" }, icon),
                React.createElement("div", null,
                    React.createElement("span", { className: "gerudo-owner-fullname" }, fullName),
                    React.createElement("span", { className: "gerudo-owner-title" }, title),
                    React.createElement("span", null, extra))),
            infoRight && (React.createElement("div", { className: "gerudo-note-info-right" },
                React.createElement("span", null, infoRight)))),
        React.createElement("div", { className: "gerudo-note-content" }, note)));
};
Note.displayName = "Note";
export default Note;
export { Note };
//# sourceMappingURL=Note.js.map